import React from 'react'
import { getMoney } from '@hlj/hlj-utils'
import Attachments from '@common/Attachments'

export default [
  {
    dataIndex: 'money',
    title: '可退还服务费金额',
    render: money => getMoney(money)
  },
  {
    dataIndex: 'remark',
    title: '订单信息',
    render: (o, { remark, attachments }) => {
      return (
        <div>
          <div>{remark}</div>
          <Attachments showUpload={false} value={attachments} />
        </div>
      )
    }
  },
  {
    dataIndex: 'innerRemark',
    title: '当时内部备注'
  }
]
